import { render, staticRenderFns } from "./todosUsuarios.vue?vue&type=template&id=9f36b902&"
import script from "./todosUsuarios.vue?vue&type=script&lang=js&"
export * from "./todosUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports